import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { ReactComponent as CrownIcon } from '../ui/icons/couronne.svg';

const CustomButton = styled(Button)<ButtonProps>({
  color: 'var(--textColor)',
  borderRadius: '0',
  padding: '4px 16px',
  height: '32px',
  textTransform: 'none',
  fontSize: '14px',
  lineHeight: '16px',
  fontWeight: '600',
  fontStyle: 'normal',
});

export const BlueButton = styled(CustomButton)({
  backgroundColor: 'var(--darkblue)',
  border: 'none',
  color: 'white',
  '&:hover': {
    backgroundColor: 'var(--lightblue)',
    color: 'var(--textColor)',
    border: 'none',
  },
});

export const YellowButton = styled(CustomButton)({
  backgroundColor: 'var(--yellow)',
  '&:hover': {
    backgroundColor: 'var(--lightyellow)',
  },
});

export const GreenButton = styled(CustomButton)({
  backgroundColor: 'var(--darkgreen)',
  color: 'white',
  '&:hover': {
    backgroundColor: 'var(--green)',
  },
});

export const WhiteButton = styled(CustomButton)({
  backgroundColor: 'white',
  border: '1px solid var(--darkblue)',
  color: 'var(--darkblue)',
  '&:hover': {
    backgroundColor: 'var(--grey)',
  },
  '& svg': {
    fill: 'var(--darkblue)',
  },
});

export const SortButton = styled(CustomButton)`
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  stroke: black;

  border-radius: 0;
  border-bottom: 3px solid transparent;
  transition: all 0.5s ease-in-out;
  opacity: 0.5;

  &:hover {
    opacity: 0.8;
  }
  &.selected {
    opacity: 1;
    border-bottom-color: var(--purple);
  }
  &.result {
    opacity: 1;
  }
  &.result:hover {
    opacity: 1;
    border-bottom-color: var(--purple);
  }
`;

export const SubscriptionButton = styled(CustomButton)(() => ({
  background: 'var(--purple)',
  color: 'white',
  border: 'none',
  '&:hover': {
    background: 'var(--lightpurple)',
    border: 'none',
  },
}));

export const SubscriptionButtonWithIcon: React.FC<ButtonProps> = (props) => (
  <SubscriptionButton
    startIcon={
      <CrownIcon style={{ width: '16px', height: '16px', fill: 'white' }} />
    }
    {...props}
  />
);

export default GreenButton;
